import PropTypes from "prop-types";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import AddTransactionModal from "../../Transactions/AddTransactionModal";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";
import PersonDetailsModal from "../../Contacts/PersonDetailsModal";
import TaskModal from "../../Tasks/components/TaskModal";

export const NewContactModal = ({ show, onClose }) => {
  const currentUser = useCurrentUser();
  const person = useMemo(
    () => ({
      isLead: true,
      primaryAgentId: currentUser.id,
      leadType: "buyer",
      typeName: "lead",
      status: "new",
    }),
    [currentUser.id],
  );
  return <PersonDetailsModal show={show} person={person} onClose={onClose} />;
};

NewContactModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export const NewTaskModal = ({ show, onClose }) =>
  show ? <TaskModal showTaskFor onClose={onClose} /> : null;

NewTaskModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export const NewTransactionModal = ({ show, onClose }) => {
  const newMilestoneId = useSelector(({ layout }) => layout.sidebar.newMilestoneId);
  return (
    <AddTransactionModal isStandalone showModal={show} onClose={onClose} newMilestoneId={newMilestoneId} />
  );
};

NewTransactionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const ACTION_MAP = {
  Leads: NewContactModal,
  People: NewContactModal,
  Tasks: NewTaskModal,
  Transactions: NewTransactionModal,
};

export default ACTION_MAP;
